import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  useTheme,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import useCustomStyles from '../../../../utils/hooks/CustomStylesHook'
import {
  DEVICE_VITAL_OVERVIEW_PRORITHM,
  getColor,
  vitalMappings,
} from './Constant'
import { useAppSelector } from '../../../../app/hooks'
import { selectProrithm, selectSafeRanges } from './DeviceSlice'
// import AddAlertIcon from '@mui/icons-material/AddAlert'
// import DataSaverOffIcon from '@mui/icons-material/DataSaverOff'
// import MonitorHeartIcon from '@mui/icons-material/MonitorHeart'

const styles = () => ({
  alertCard: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '20px',
    border: '1px solid #B6D1D9',
    padding: 'unset',
  },
  alertCardContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'center',
    gap: 10,
    rowGap: 15,
  },
  alertCardContentSub: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    gap: 10,
    rowGap: 15,
  },
  alertCardTitleProrithm: {
    display: 'flex',
    justifyContent: 'center',
    borderBottom: '1px solid #B6D1D9',
    borderRadius: '0px 11px 0px 20px',
    fontSize: '10px',
    fontWeight: 'bold',
    padding: '2px 8px 2px 8px',
    background: 'linear-gradient(180deg, #8ED6C9 -100%, #FFFFFF 102.47%)',
    color: '#3B7D72',
    width: 'fit-content',
    overflow: 'hidden',
    // float: 'right !important',
    alignSelf: 'end',
  },
  alertCardTitleRing: {
    display: 'flex',
    justifyContent: 'center',
    borderBottom: '1px solid #B6D1D9',
    borderRadius: '0px 11px 0px 20px',
    fontSize: '10px',
    fontWeight: 'bold',
    padding: '2px 8px 2px 8px',
    background: 'linear-gradient(180deg, #5FC3E0 -100%, #FFFFFF 102.47%)',
    color: '#237F97',
    width: 'fit-content',
    overflow: 'hidden',
    // float: 'right !important',
    alignSelf: 'end',
  },
  alertCardVitalText: {
    fontSize: '15px',
    fontWeight: 400,
    padding: '5px',
  },
  alertCardVitalRange: {
    fontSize: '20px',
    fontWeight: 600,
    padding: '5px',
    color: 'red',
  },
  alertCardWarningText: {
    fontSize: '24px',
    fontWeight: 500,
    padding: '5px',
    color: 'red',
    textAlign: 'center',
  },
  alertCardVitalUnit: {
    fontSize: '10px',
    fontweight: 600,
    marginLeft: 2,
  },
})

const Overview = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  const proRithmVitals: Record<string, any> = useAppSelector(selectProrithm)
  const safeRanges = useAppSelector(selectSafeRanges)

  // State storing the values for each vital sign
  const proRithmVitalState: any = {
    heartRate: proRithmVitals?.hr?.[0]?.v || null,
    spo2: proRithmVitals?.spo2?.[0]?.v || null,
    bloodPressureSystolic: proRithmVitals?.bp?.[0]?.sp || null,
    bloodPressureDiastolic: proRithmVitals?.bp?.[0]?.dp || null,
    skinTemperature: proRithmVitals?.skt?.[0]?.v || null,
    respiratoryRate: proRithmVitals?.rr?.[0]?.v || null,
    heartRateVar: proRithmVitals?.hrv?.[0]?.v || null,
  }

  // const smartRingVitalState: any = {
  //   heartRate: 106,
  //   spo2: 78,
  //   bloodPressure: '0/0',
  //   skinTemperature: 36.5,
  //   respiratoryRate: 16,
  //   heartRateVar: 50,
  //   stress: 20,
  //   sleep: 7,
  // }

  const [alerts, setAlerts] = useState([])

  const generateAlerts = (
    safeRanges: Record<string, { min: number; max: number }>,
    vitals: Record<string, any>
  ) => {
    const alerts: any = []

    // Iterate through each vital mapping and check safe ranges
    vitalMappings?.forEach(({ key, name, unit, safeKey, subKey }) => {
      const value = subKey
        ? vitals?.[key]?.[0]?.[subKey]
        : vitals?.[key]?.[0]?.v

      if (value !== undefined && safeRanges?.[safeKey]) {
        if (
          value < safeRanges?.[safeKey]?.min ||
          value > safeRanges?.[safeKey]?.max
        ) {
          alerts.push({
            device: 'ProRithm',
            vitalName: name,
            vitalValue: value,
            vitalUnit: unit,
          })
        }
      }
    })

    setAlerts(alerts)
  }

  useEffect(() => {
    generateAlerts(safeRanges, proRithmVitals)
  }, [proRithmVitals, safeRanges])

  return (
    <Grid container direction='row' rowGap={3} spacing={1.5}>
      <Grid item xs={12} sm={12} md={8} lg={8} xl={6}>
        <Typography variant='h6' mb={2}>
          Alerts
        </Typography>
        <Grid container spacing={2}>
          {alerts?.map((item: any, index) => (
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6} key={index}>
              <Card className={classes?.alertCard} elevation={0}>
                <Typography
                  className={
                    item?.device === 'ProRithm'
                      ? classes?.alertCardTitleProrithm
                      : classes?.alertCardTitleRing
                  }
                >
                  {item?.device}
                </Typography>
                <CardContent className={classes?.alertCardContent}>
                  <Box className={classes?.alertCardContentSub}>
                    <Typography className={classes?.alertCardVitalText}>
                      {item?.vitalName}
                    </Typography>
                    <Typography className={classes?.alertCardVitalRange}>
                      {item?.vitalValue}{' '}
                      <span className={classes?.alertCardVitalUnit}>
                        {' '}
                        {item?.vitalUnit}
                      </span>
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} xl={6}>
        <Grid item xs={12} mb={4}>
          <Typography variant='h6'>Prorithm</Typography>
          {DEVICE_VITAL_OVERVIEW_PRORITHM?.map((item, index) => {
            const value = proRithmVitalState[item?.key]
            const color = getColor(
              safeRanges,
              item?.key,
              typeof value === 'string'
                ? parseInt(value?.split('/')[0]) || 0
                : value
            )

            return (
              <Box
                key={index}
                display='flex'
                justifyContent='space-between'
                alignItems='center'
                border='1px solid lightgray'
                borderRadius='10px'
                padding='10px'
                margin='10px'
                boxSizing={'border-box'}
              >
                <Box display={'flex'} alignItems={'center'} gap={2}>
                  <item.icon color={'#183f7c'} width={30} height={30} />
                  <Typography>{item?.label}</Typography>{' '}
                </Box>
                <Box color={color} fontWeight={'bold'}>
                  {value ?? 'N/A'}
                </Box>
              </Box>
            )
          })}
        </Grid>
        {/* <Grid item xs={12}>
          <Typography variant='h6'>Smart Ring</Typography>
          {DEVICE_VITAL_OVERVIEW_SMART_RING?.map((item, index) => {
            const value = smartRingVitalState[item?.key]
            const color = getColor(
              item?.key,
              typeof value === 'string'
                ? parseInt(value?.split('/')[0]) || 0
                : value
            )

            return (
              <Box
                key={index}
                display='flex'
                justifyContent='space-between'
                alignItems='center'
                border='1px solid lightgray'
                borderRadius='10px'
                padding='10px'
                margin='10px'
                boxSizing={'border-box'}
              >
                <Box display={'flex'} alignItems={'center'} gap={2}>
                  <item.icon color={'#183f7c'} width={30} height={30} />
                  <Typography>{item?.label}</Typography>{' '}
                </Box>
                <Box color={color} fontWeight={'bold'}>
                  {value ?? 'N/A'}
                </Box>
              </Box>
            )
          })}
        </Grid> */}
      </Grid>
    </Grid>
  )
}

export default Overview
